<template>
	<div v-if="showProFeatures(webLocale)">
		<FilterReleaseYear :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterBarGenres :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterRating :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterProductionCountry :current-filters="currentFilters" />
		<FilterVoteCount :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterRuntime :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterPrice :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterMonetizationTypes :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterAgeCertification :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterPresentationTypes :collectionType="collectionType" :currentFilters="currentFilters" />
		<div style="padding-bottom: 30px"></div>
	</div>
	<div v-else>
		<FilterReleaseYear :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterRating :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterPrice :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterMonetizationTypes :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterBarGenres :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterPresentationTypes :collectionType="collectionType" :currentFilters="currentFilters" />
		<FilterAgeCertification :collectionType="collectionType" :currentFilters="currentFilters" />
		<div style="padding-bottom: 30px"></div>
	</div>
</template>
<script setup lang="ts">
import { FilterProductionCountry, FilterRuntime, FilterVoteCount } from '@/lazy-load-components';

import FilterAgeCertification from '@/components/filter-bar/FilterAgeCertification.vue';
import FilterBarGenres from '@/components/filter-bar/FilterBarGenres.vue';
import FilterMonetizationTypes from '@/components/filter-bar/FilterMonetizationTypes.vue';
import FilterPresentationTypes from '@/components/filter-bar/FilterPresentationTypes.vue';
import FilterPrice from '@/components/filter-bar/FilterPrice.vue';
import FilterRating from '@/components/filter-bar/FilterRating.vue';
import FilterReleaseYear from '@/components/filter-bar/FilterReleaseYear.vue';

import { CollectionType } from '@/enums/collection-type';
import type { FilterCollection } from '@/stores/useFilterStoreTypes';
import { showProFeatures } from '@/helpers/pro-web-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';

defineProps<{
	collectionType: CollectionType;
	currentFilters: FilterCollection;
}>();

const { webLocale } = storeToRefs(useLanguageStore());
</script>

<style lang="scss"></style>
